import { Show, useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs';
import { DashboardContent } from 'src/layouts/dashboard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionGuard } from 'src/routes/components';
import { Resources } from '../resource';
import UserDetail from './UserDetail';


const UserDetailShow = () => {
  const t = useTranslate();

  return (
    <PermissionGuard resource="user-info" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent>
        <CustomBreadcrumbs
          heading={t('module.userInfo.title')}
          links={[
            { name: t('module.userInfo.title'), href: `/${Resources.userInfo}` },
            { name: t('module.userInfo.detail') },
          ]}
        />
        <Show>
          <UserDetail/>
        </Show>
      </DashboardContent>
    </PermissionGuard>
  );
};

export default UserDetailShow;
